module.exports = __webpack_public_path__ + "img/food_fries.3e728566.png";